/**
 * Created by jonas on 2020-11-05.
 */
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";


export interface WinSoundConfig {
    init?:string;
    start?:string;
    end:string;
}

export class WinConfig {

    public readonly fromRatioDefault:number;
    public readonly toRatioDefault:number;
    public readonly durationDefault:number;
    public readonly isBigWin:boolean;

    public duration:number;
    public anim?:string;
    public level:number;
    public fromRatio:number;
    public toRatio:number;
    public sound?:WinSoundConfig;
    public particleLevel:number = 0;
    public name:string;

    public newMultiplier:boolean = true;
    public multiplier:number = 1;
    public durationRatio:number = 1;
    public textScale:number;

    constructor(name:string, fromRatio:number, toRatio:number, duration:number, textScale:number, sound?:WinSoundConfig, anim?:string, particleLevel:number = 0, isBigWin:boolean = false) {
        this.name = name;
        this.fromRatioDefault = fromRatio;
        this.toRatioDefault = toRatio;
        this.durationDefault = duration;

        this.textScale = textScale;

        this.particleLevel = particleLevel;
        this.isBigWin = isBigWin;
        this.fromRatio = fromRatio;
        this.toRatio = toRatio;
        this.duration = duration;

        this.anim = anim;
        this.sound = sound;
    }

    public reset():WinConfig {
        this.toRatio = this.toRatioDefault;
        this.fromRatio = this.fromRatioDefault;
        return this;
    }

    public clone():WinConfig {
        return new WinConfig(this.name, this.fromRatioDefault, this.toRatioDefault, this.durationDefault, this.textScale, this.sound, this.anim, this.particleLevel, this.isBigWin);
    }

    public calculateDuration() {
        const defaultRatio = this.toRatioDefault - this.fromRatioDefault;
        let ratio = Math.min(this.toRatio, this.toRatioDefault) - Math.max(this.fromRatio, this.fromRatioDefault);
        this.durationRatio = ratio / defaultRatio;

        if(this.toRatioDefault == Number.MAX_VALUE) {
            this.durationRatio = 1;
        }
    }


    public calculateDurationNew(levelStartRatio:number, levelEndRatio:number):number {
        const ratio = this.toRatio - this.fromRatio;
        const levelRatio = levelEndRatio - levelStartRatio;
        return ratio / levelRatio;
    }


}

export class WinConfigUtil {

    public static TINY = new WinConfig("TINY", 0, 1.5, 0.001, 0.7, {
        init : "",
        start : "",
        end : ""
    });
    public static SMALL = new WinConfig("SMALL", 1.5, 3, 0.2, 0.75, {
        init : "",
        start : "",
        end : ""
    });
    public static MEDIUM = new WinConfig("MEDIUM", 3, 5, 0.5, 0.85, {
        init : "",
        start : "",
        end : ""
    });
    public static LARGE = new WinConfig("LARGE", 5, 15, 0.8, 0.9, {
        init : "",
        start : "",
        end : ""
    });

    //15x, 25x, 50x, 100x, 250x, 500+
    public static BIG_1 = new WinConfig("BIG_1", 0, 25, 5, 0.5, {
        init : "",
        start : XwaysHoarder2Sound.BIGWIN_LEVELS[0],
        end :  ""
    }, "level1Start", 1, true);
    public static BIG_2 = new WinConfig("BIG_2", 25, 50, 5, 0.65, {
        init : "",
        start : XwaysHoarder2Sound.BIGWIN_LEVELS[1],
        end :  ""
    }, "level2Start", 2, true);
    public static BIG_3 = new WinConfig("BIG_3", 50, 100, 5, 0.8, {
        init :  "",
        start : XwaysHoarder2Sound.BIGWIN_LEVELS[2],
        end :  ""
    }, "level3Start", 3, true);

    public static BIG_4 = new WinConfig("BIG_4", 100, 250, 5, 1.0, {
        init :  "",
        start :  XwaysHoarder2Sound.BIGWIN_LEVELS[3],
        end :  ""
    }, "level4Start", 4, true);

    public static BIG_5 = new WinConfig("BIG_5", 250, 500, 5, 1.0, {
        init :  "",
        start :  XwaysHoarder2Sound.BIGWIN_LEVELS[4],
        end :  ""
    }, "level5Start", 5, true);


    public static normalLevels:WinConfig[] = [
        WinConfigUtil.TINY,
        WinConfigUtil.SMALL,
        WinConfigUtil.MEDIUM,
        WinConfigUtil.LARGE,
    ];
    public static bigLevels:WinConfig[] = [
        WinConfigUtil.BIG_1,
        WinConfigUtil.BIG_2,
        WinConfigUtil.BIG_3,
        WinConfigUtil.BIG_4,
        WinConfigUtil.BIG_5
    ];

    static randomIntFromInterval(min:number, max:number):number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    public static getNormalWinLevels(fromRatio:number, winRatio:number, multiplier:number = 1, lastRange:boolean):WinConfig[] {
        let result:WinConfig[] = []

        for(let i:number = 0; i < WinConfigUtil.normalLevels.length; i++) {
            const level = WinConfigUtil.normalLevels[i];
            if(fromRatio > level.toRatio) {
                continue;
            }
            if(winRatio >= level.fromRatio) {
                const newLevel = level.clone();
                newLevel.multiplier = multiplier;
                result = [newLevel];
            }
        }


        result = WinConfigUtil.setFirstConfig(fromRatio, result);
        result = WinConfigUtil.setLastConfig(winRatio, result, lastRange);
        return result;
    }

    public static getBigWinLevels(fromRatio:number, winRatio:number, multiplier:number = 1, lastRange:boolean):WinConfig[] {
        let result:WinConfig[] = []

        for(let i:number = 0; i < WinConfigUtil.bigLevels.length; i++) {
            const level = WinConfigUtil.bigLevels[i];
            if(fromRatio > level.toRatio) {
                continue;
            }
            if(winRatio >= level.fromRatio) {
                const newLevel = level.clone();
                newLevel.multiplier = multiplier;
                result.push(newLevel);
            }
        }

        result = WinConfigUtil.setFirstConfig(fromRatio, result);
        result = WinConfigUtil.setLastConfig(winRatio, result, lastRange);
        return result;
    }

    private static setFirstConfig(fromRatio:number, configs:WinConfig[]):WinConfig[] {
        let firstConfig = configs[0];
        firstConfig.fromRatio = fromRatio;
        firstConfig.calculateDuration();
        return configs;
    }

    private static setLastConfig(winRatio:number, configs:WinConfig[], lastRange:boolean):WinConfig[] {
        let lastConfig = configs[configs.length - 1];
        if(lastConfig.fromRatio * 1.1 > winRatio && configs.length > 1) {
            configs.pop();
            return WinConfigUtil.setLastConfig(winRatio, configs, lastRange);
        }

        lastConfig.toRatio = winRatio;
        lastConfig.calculateDuration();
        return configs;
    }


}

